/**
 * Three.js unfortunately still uses onLoad and onError function property
 * callbacks in some areas. This procedure is used to adapt those functions to
 * use Signals. We examine the given object for the named property, e.g.
 * 'onLoad', and if we find it, we replace it with a new function that calls
 * both the pre-existing handler and the given signal trigger function. If the
 * named function property is undefined or null, then we simply assign the
 * given trigger function as its value.
 */
export const overloadHandlerFunction =
    (obj: object, name: string, trigger: (...args: unknown[]) => unknown) =>
{
    if(obj[name] && (typeof obj[name] == 'function')) {
        const original = obj[name];
        obj[name] = (...args: unknown[]) => {
            trigger(...args);
            return original(...args);
        }
    } else {
        obj[name] = trigger;
    }
}
